module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'goodsScroll') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品类型"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.config.type),
      callback: function($$v) {
        _vm.$set(_vm.config, "type", $$v)
      },
      expression: "config.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'goods'
    }
  }, [_vm._v("单商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'seckill'
    }
  }, [_vm._v("秒杀活动")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'limitTimeSale'
    }
  }, [_vm._v("限时特惠")])], 1)], 1), _vm._v(" "), (_vm.config.type === 'goods') ? _c('el-form-item', {
    attrs: {
      "label": "开启排行榜"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.leaderboard),
      callback: function($$v) {
        _vm.$set(_vm.config, "leaderboard", $$v)
      },
      expression: "config.leaderboard"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "显示价格"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.showPrice),
      callback: function($$v) {
        _vm.$set(_vm.config, "showPrice", $$v)
      },
      expression: "config.showPrice"
    }
  })], 1), _vm._v(" "), (_vm.config.type === 'goods') ? _c('el-form-item', {
    attrs: {
      "label": "选择商品"
    }
  }, [_c('draggable', {
    staticClass: "content-bottom-padded",
    attrs: {
      "options": _vm.dragItemsOptions
    },
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item item-selected"
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })])])
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-cog banner-button-uploader",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.setGoods
    }
  }, [_vm._v(" 设置商品")])], 1) : _vm._e(), _vm._v(" "), (_vm.config.type === 'seckill') ? _c('el-form-item', {
    attrs: {
      "label": "选择活动"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectSeckill
    },
    model: {
      value: (_vm.config.seckillId),
      callback: function($$v) {
        _vm.$set(_vm.config, "seckillId", $$v)
      },
      expression: "config.seckillId"
    }
  }, _vm._l((_vm.seckill), function(item, index) {
    return _c('el-option', {
      key: item.seckill_id,
      attrs: {
        "label": item.activity_name,
        "value": item.seckill_id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.type === 'limitTimeSale') ? _c('el-form-item', {
    attrs: {
      "label": "选择活动"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectLimitTimeSale
    },
    model: {
      value: (_vm.config.seckillId),
      callback: function($$v) {
        _vm.$set(_vm.config, "seckillId", $$v)
      },
      expression: "config.seckillId"
    }
  }, _vm._l((_vm.limitTimeSale), function(item, index) {
    return _c('el-option', {
      key: item.seckill_id,
      attrs: {
        "label": item.activity_name,
        "value": item.seckill_id
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a37830d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a37830d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/goods_scroll.vue
// module id = 2896
// module chunks = 0